@if (!disabled()) {
  <mat-form-field
    appearance="outline"
    class="sia-inputs-full sia-input"
    floatLabel="always"
    [class]="inputClass()"
    [subscriptSizing]="showBottomMargin() ? 'fixed' : 'dynamic'"
  >
    <mat-label
      >{{ label() | siaTranslate }}
      @if (info()) {
        <span
          [siaTooltip]="info() ?? ''"
          position="right"
          class="sia-info"
          [innerHTML]="infoIcon()"
        >
        </span>
      }
    </mat-label>
    <input
      matInput
      type="text"
      [ngModel]="stringValue()"
      (ngModelChange)="onStringValueChange($event)"
      (focusout)="formatInputString()"
      (keyup.enter)="formatInputString()"
      (keyup)="formatInputString(false)"
      (keyup.f1)="setAsToday()"
      [id]="id() ?? ''"
      [tabindex]="tabDisabled() ? '-1' : '0'"
    />
    <input
      style="height: 0; position: absolute"
      type="text"
      matInput
      [matDatepicker]="picker"
      [ngModel]="value()"
      (ngModelChange)="updateValue($event)"
      [disabled]="isDisabled()"
      [min]="dateMin()"
      [max]="dateMax()"
      [readonly]="true"
      inputmode="none"
      autocomplete="off"
      [tabindex]="'-1'"
    />
    <mat-datepicker-toggle matIconSuffix [for]="picker">
    </mat-datepicker-toggle>
    <mat-datepicker #picker> </mat-datepicker>
    @if (showBottomMargin()) {
      <mat-hint
        sia-error-hint
        [statusMessage]="statusMessage()"
        [statusMessages]="statusMessages()"
      ></mat-hint>
    }
  </mat-form-field>
} @else {
  <sia-text-box
    class="sia-inputs-full sia-input"
    [value]="value() ?? '' | date: format() ?? 'dd/MM/yyyy'"
    [disabled]="true"
    [label]="label()"
    [status]="status()"
    [statusMessage]="statusMessage()"
    [showBottomMargin]="showBottomMargin()"
  >
  </sia-text-box>
}
